import { ComponentType } from 'react';
import { Dispatch } from 'redux';
import { DeletionPolicyUpdate, RetentionPeriodsByEventName } from './deletionPolicies';
import { CustomEventPermission } from './projects';
import { CustomEvent, WorkflowNodeReference } from './usageMetrics';

export * from './deletionPolicies';
export * from './projects';
export * from './usageMetrics';

/** Custom event data merged from various API sources for use in table */
export type MergedCustomEvent = {
  allowed: boolean;
  /** number of times a custom event has been seen  */
  docCount: number;
  eventName: string;
  /** integer timestamp of when event was last processed */
  lastSeen: number;
  /** dynamic lists that reference this event */
  listReferences: number;
  references: number;
  /** number (days) to store this event */
  retentionPolicy: number;
  saved: boolean;
  /** workflow nodes that contain this event */
  workflowReferences: number;
  /** workflow nodes that trigger this event */
  workflowTriggers: WorkflowNodeReference[];
};

export enum INGESTION_POLICIES {
  SAVED = 'Saved',
  DISCARDED = 'Discarded',
  DEACTIVATED = 'Deactivated',
  ALL = 'All',
}

export type State = {
  settings: {
    customEvents: {
      customEvents: CustomEvent[];
      isLoading: boolean;
      isError: boolean;
      isLoadingDeletionPolicies: boolean;
      retentionPeriodsByEventName: RetentionPeriodsByEventName;
      isErrorDeletionPolicies: boolean;
    };
  };
  [key: string]: any;
};

export type Action = {
  type: string;
};

export type CustomEventsRequestAction = Action & {
  queryString: string;
  dispatch: Dispatch<any>;
};

export type CustomEventsResponseAction = Action & {
  customEvents: CustomEvent[];
};

export type CustomEventsErrorAction = Action & {
  error: string;
};

export type MappingErrorResponse = {
  projectId: number;
  fieldName: string;
  reason?: string;
};

export type FetchDeletionPoliciesResponseAction = Action & {
  retentionPeriodsByEventName: RetentionPeriodsByEventName;
};

export type UpdateDeletionPoliciesAction = Action & {
  deletionPolicyUpdate: DeletionPolicyUpdate;
};

export type UpdateCustomEventSettingsRequestPayload = {
  projectId: number;
  allowNewCustomEvents: boolean;
  customEventPermissions: CustomEventPermission[];
};

export type RetentionPeriodFormData = {
  input: string;
  radio: string;
  select: 'days' | 'years';
};

export type CustomEventsCacheType = {
  [key: string]: MergedCustomEvent[];
};

export type EmptyStateConfig = {
  Icon: ComponentType<React.PropsWithChildren<unknown>>;
  title: string;
  subtitle: string;
};
